import eventBus from '@ms/utils/event-bus.js'
import { computed, ref } from '@vue/composition-api'

const KEY_USER_PHONE = 'm_sport_user_phone'

export default function usePhone() {
  const defaultPhone = localStorage.getItem(KEY_USER_PHONE) || ''
  const phone = ref(defaultPhone)

  // 格式化显示 phone
  const safePhone = computed(() => {
    const phoneValue = phone.value
    const len = phoneValue.length
    if (phoneValue && len > 6) {
      return phoneValue.substring(0, 3) + '*'.repeat(len - 6) + phoneValue.substring(len - 3, len)
    } else {
      return ''
    }
  })

  const convertToSafePhone = (value) => {
    if (value && value.length > 6) {
      return value.substring(0, 3) + '*'.repeat(value.length - 6) + value.substring(value.length - 3, value.length)
    } else {
      return ''
    }
  }

  const setPhone = (value) => {
    phone.value = value
    localStorage.setItem(KEY_USER_PHONE, value)
  }
  const removePhone = () => {
    phone.value = ''
    localStorage.removeItem(KEY_USER_PHONE)
  }

  window.addEventListener('storage', (event) => {
    if (event.key === KEY_USER_PHONE && event.newValue && event.newValue !== event.oldValue) {
      setPhone(event.newValue)
      eventBus.$emit('phone-change')
    }
  })

  return {
    phone,
    safePhone,
    setPhone,
    removePhone,
    convertToSafePhone
  }
}
